import { MutationTree } from 'vuex';
import { State } from '@/manager/product/store/state';
import { Product } from '@/manager/product/models/product.model';

export interface Mutations {
    setProductList: {list: Product[]};
}

export const mutations: MutationTree<State> = {
    setProductList: (state, payload) => {
        state.list = payload;
    },
    checkSetProductList: (state, payload) => {
        payload.forEach( (newProduct: Product) => {
            const existingProduct = state.list.find((product: Product) => {
                return product.id === newProduct.id;
            });
            if (!existingProduct) {
                state.list.push(newProduct);
            }

        });
    },
};
